import styled from 'styled-components'

import { flexRow } from '~/shared/styles/layout'

export const Wrapper = styled.div`
  ${flexRow}
  justify-content: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'spaced' does not exist on type 'ThemedSt... Remove this comment to see the full error message
    props.spaced ? 'space-between' : 'flex-end'};
`
